import React from "react"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import Col from "@bappweb/col"
import Row from "@bappweb/row"
import Grid from "@bappweb/grid"
import "../assets/style.scss"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="landing-header-text-wrapper">
        <Grid>
          <Row>
            <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1} />
          </Row>
        </Grid>
      </Block>
      <Image
        path={"./img/konutkredisi/landing-header.png"}
        className="landing-header-img landing-header-img-desktop"
      />
      <Image
        path={"./img/konutkredisi/landing-header-mobile.png"}
        className="landing-header-img landing-header-img-mobile"
      />
    </Block>
  )
}

export default LandingHeader
